module.exports = __webpack_public_path__ + "media/images/pc/special_plans/separator_skyblue-480b4e950c0d4ab65e29752f17d9c355.png";